// https://vuex.vuejs.org/en/mutations.html

export default {
  showSnackbar (state, { message, color }) {
    // todo check validity of data
    state.snackbar.message = message
    state.snackbar.color = color
    state.snackbar.active = true
  },
  SET_BAR_IMAGE (state, payload) {
    state.barImage = payload
  },
  SET_DRAWER (state, payload) {
    state.drawer = payload
  },
  TOGGLE_DRAWER_MINI (state, payload) {
    state.drawerSettings.mini = !state.drawerSettings.mini
  },
  SET_SCRIM (state, payload) {
    state.barColor = payload
  },
  refreshContentSettings (state, settings) {
    state.contentSettings = settings
  },
}
